import { CreateElement, VNode, VNodeData } from 'vue';
import { Component, Prop, Vue } from 'vue-property-decorator';
import ClTypography from '../ClTypography';

type Color = 'default' | 'primary' | 'inherit';

@Component({
  components: { ClTypography }
})
export default class ClListSubheader extends Vue {
  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  @Prop({
    type: String as () => Color,
    validator: x => ['default', 'primary', 'inherit'].includes(x),
    default: 'default'
  })
  public color!: Color;

  /**
   * The component used for the root node.
   */
  @Prop({
    type: String,
    default: 'li'
  })
  public component!: string;

  /**
   * If true, the component will not have gutters.
   */
  @Prop({
    type: Boolean,
    default: false
  })
  public disableGutters!: boolean;

  /**
   * If true, the component will not stick to the top during scroll.
   */
  @Prop({
    type: Boolean,
    default: false
  })
  public disableSticky!: boolean;

  /**
   * If true, the component will be indented.
   */
  @Prop({
    type: Boolean,
    default: false
  })
  public inset!: boolean;

  public render(h: CreateElement): VNode {
    const data: VNodeData = {
      class: {
        'cl-list-subheader': true,
        [`cl-list-subheader--color-${this.color}`]: this.color !== 'default',
        'cl-list-subheader--inset': this.inset,
        'cl-list-subheader--sticky': !this.disableSticky,
        'cl-list-subheader--gutters': !this.disableGutters
      }
    };
    return h(this.component, data, this.$slots.default);
  }
}
